import React, { useEffect, useState } from "react";
import { Card, Button, Input, Table, Spin, message } from "antd";
import Api from "../api/Api";

const Turno = () => {
  const [loading, setLoading] = useState(false);
  const [turno, setTurno] = useState(null);
  const [docum, setDocum] = useState([]);
  const [turnoFechado, setTurnoFechado] = useState(null); // último turno fechado


  useEffect(() => {
    document.title = "Gestão de Turno";
    carregarTurno();
  }, []);

  const sms_success = (msg) => message.success(msg);
  const sms_error = (msg) => message.error(msg);

  // ---------------------------
  // LISTA O TURNO
  // ---------------------------
const carregarTurno = async () => {
  setLoading(true);

  try {
    const response = await Api.ListTurno();

    // -------------------------
    // CASO 1: TURNO ABERTO
    // -------------------------
    if (response && response.id && response.abertura && !response.fecho) {

      setTurno(response);        // turno aberto
      setTurnoFechado(null);     // limpa turno fechado
      localStorage.setItem("id_turno", response.id);
    }

    // -------------------------
    // CASO 2: NÃO TEM TURNO ABERTO
    // -------------------------
    else if (response.success === false) {

      const response2 = await Api.ListTurnoFechado();

      setTurno(null);             // NÃO considerar aberto
      setTurnoFechado(response2); // guardar turno fechado
      localStorage.removeItem("id_turno");
    }

    else {
      setTurno(null);
      setTurnoFechado(null);
      localStorage.removeItem("id_turno");
    }

  } catch (e) {
    sms_error("Erro ao carregar turno");
  }

  gerarDocsFake();
  setLoading(false);
};




  // ---------------------------
  // ABRIR TURNO
  // ---------------------------
  const abrirTurno = async () => {
    setLoading(true);

    try {
      const r = await Api.AbrirTurno();

      if (r.id_turno) {
        localStorage.setItem("id_turno", r.id_turno);
        sms_success("Turno aberto com sucesso");
        carregarTurno();
      }
    } catch {
      sms_error("Erro ao abrir turno");
    }

    setLoading(false);
  };

  // ---------------------------
  // FECHAR TURNO
  // ---------------------------
  const fecharTurno = async () => {
    setLoading(true);


    const id_turno = localStorage.getItem('id_turno');
    const dados={id_turno:id_turno};
 
    try {
      const r = await Api.FecharTurno(dados);

      if (r.success) {
        sms_success(r.message);
        localStorage.removeItem("id_turno");
        setTurno(null);
      }
    } catch {
      sms_error("Erro ao fechar turno");
    }

    setLoading(false);
  };

  // ---------------------------
  // DOCUMENTOS FICTÍCIOS
  // ---------------------------
  const gerarDocsFake = () => {
    setDocum([
      { id: 1, numero: "FAT-001", total: "10.000,00", tipo: "Factura" },
      { id: 2, numero: "FAT-002", total: "4.800,00", tipo: "Factura" },
      { id: 3, numero: "REC-033", total: "2.000,00", tipo: "Recibo" },
    ]);
  };

  const colunasDocumento = [
    { title: "Nº Documento", dataIndex: "numero" },
    { title: "Tipo", dataIndex: "tipo" },
    { title: "Total", dataIndex: "total" },
  ];

  return (
    <div style={{ padding: 24, background: "#f5f5f5", minHeight: "100vh" }}>
      <Card
        title="Gestão de Turno"
        style={{
          borderRadius: 10,
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        }}
      >
        <Spin spinning={loading}>
          <div style={{ display: "flex", gap: 20 }}>
  {/* -----------------------------------------
      LADO ESQUERDO
  ----------------------------------------- */}
  <Card
    title="Ações"
    style={{ width: "30%", borderRadius: 10 }}
    headStyle={{
      background: "#fafafa",
      borderBottom: "2px solid #1890ff",
      fontWeight: "bold",
    }}
  >

    {/* -------------------- TURNO ID -------------------- */}
 {turno && (
  <div style={{ marginBottom: 20, padding: 10, background: "#e6f7ff", borderRadius: 6 }}>
    Turno em aberto Nº: {turno.id}
  </div>
)}

{!turno && turnoFechado && (
  <div style={{ marginBottom: 20, padding: 10, background: "#fffbe6", borderRadius: 6 }}>
    Último turno fechado Nº: {turnoFechado.id}
  </div>
)}


    {/* BOTÕES */}
<div style={{ display: "flex", gap: 10, marginBottom: 20 }}>

  {/* Se NÃO há turno aberto → mostrar botão Abrir */}
  {!turno && (
    <Button
      type="primary"
      block
      onClick={abrirTurno}
      style={{ height: 45, fontSize: 16 }}
    >
      Abrir Turno
    </Button>
  )}

  {/* Se há turno aberto → mostrar botão Fechar */}
  {turno && (
    <Button
      danger
      block
      onClick={fecharTurno}
      style={{ height: 45, fontSize: 16 }}
    >
      Fechar Turno
    </Button>
  )}

</div>


    {/* CAMPOS COM LABEL */}
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>

      <div>
        <label>Data de abertura</label>
        <Input disabled value={turno?.abertura || turnoFechado?.abertura || ""} />
      </div>

      <div>
        <label>Data de fecho</label>
         <Input disabled value={turno?.fecho || turnoFechado?.fecho || ""} />
      </div>

      <div>
        <label>Valor inicial</label>
         <Input disabled value={turno?.inicial || turnoFechado?.inicial || ""} />
      </div>

      <div>
        <label>Valor final</label>
         <Input disabled value={turno?.final || turnoFechado?.final || ""} />
      </div>

      <div>
        <label>Entrada no caixa</label>
         <Input disabled value={turno?.entrada || turnoFechado?.entrada || ""} />
      </div>

      <div>
        <label>Saída no caixa</label>
         <Input disabled value={turno?.saida || turnoFechado?.saida || ""} />
      </div>

      <div>
        <label>Valor informado</label>
         <Input disabled value={turno?.informado || turnoFechado?.informado || ""} />
      </div>

      <div>
        <label>Diferença</label>
         <Input disabled value={turno?.diferenca || turnoFechado?.diferenca || ""} />
      </div>

    </div>
  </Card>

  {/* -----------------------------------------
      LADO DIREITO - DOCUMENTOS
  ----------------------------------------- */}
  <Card
    title="Documentos Emitidos"
    style={{ flex: 1, borderRadius: 10 }}
    headStyle={{
      background: "#fafafa",
      borderBottom: "2px solid #1890ff",
      fontWeight: "bold",
    }}
  >
    <Table
      columns={colunasDocumento}
      dataSource={docum}
      pagination={{ pageSize: 6 }}
      rowKey="id"
    />
  </Card>
</div>

        </Spin>
      </Card>
    </div>
  );
};

export default Turno;
